"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketCorsInput_1 = require("./PutBucketCorsInput");
var PutBucketCorsOutput_1 = require("./PutBucketCorsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketCors = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketCors",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?cors"
    },
    input: {
        shape: PutBucketCorsInput_1.PutBucketCorsInput
    },
    output: {
        shape: PutBucketCorsOutput_1.PutBucketCorsOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketCors.js.map